var _a;
import { jsx } from "react/jsx-runtime";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import rehypeSanitize, { defaultSchema } from "rehype-sanitize";
import { B as Box, c as ce } from "./Grid-CcQKdsgp.js";
const customSchema = {
  ...defaultSchema,
  tagNames: [...(_a = defaultSchema.tagNames) != null ? _a : [], "button", "style", "iframe"],
  attributes: {
    ...defaultSchema.attributes,
    "*": ["class", "className", "style", "id"],
    a: ["href", "target", "rel"],
    iframe: ["src", "width", "height", "allow", "frameborder"]
  },
  protocols: {
    ...defaultSchema.protocols,
    src: ["https"],
    href: ["https", "mailto"]
  }
};
const markdownStyles = ce({
  variants: {
    alignment: {
      left: "text-left",
      center: "text-center",
      right: "text-right",
      justify: "text-justify"
    }
  },
  defaultVariants: {
    alignment: "left"
  }
});
const Markdown = (props) => {
  const {
    children,
    className,
    alignment = "left",
    clobberPrefix = "user-content-",
    ...indentationProps
  } = props;
  return /* @__PURE__ */ jsx(
    Box,
    {
      ...props,
      style: {
        ...indentationProps.style
      },
      children: /* @__PURE__ */ jsx(
        ReactMarkdown,
        {
          className: markdownStyles({
            className: className != null ? className : "",
            alignment
          }),
          rehypePlugins: [
            rehypeRaw,
            [
              rehypeSanitize,
              {
                ...customSchema,
                clobberPrefix
              }
            ]
          ],
          children
        }
      )
    }
  );
};
export {
  Markdown as M
};
